import { render } from "./Office.vue?vue&type=template&id=66866214"
const script = {}

import exportComponent from "/Users/andressantos/Documents/kevin/matrix_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__